import script from "./Mark.vue?vue&type=script&lang=ts&setup=true"
export * from "./Mark.vue?vue&type=script&lang=ts&setup=true"

import "./Mark.vue?vue&type=style&index=0&id=45f4e6d0&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f4e6d0"]])

export default __exports__